<template>
  <el-dialog
    class="rc-dialog"
    :title="title"
    :visible.sync="isShow"
    :close-on-click-modal="false"
    @close="clearForm"
    width="500px"
  >
    <el-form
      ref="rForm"
      :model="rObject"
      size="small"
      :rules="rules"
      label-position="right"
      label-width="100px"
      class="form"
    >
      <el-row>
        <el-col>
          <el-form-item label="分类名称：" prop="categoryName">
            <el-input
              v-model="rObject.categoryName"
              placeholder="请填写分类名称"
              @input="input"
              @blur="blur"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="分类简称：" prop="showName">
            <el-input
              v-model="rObject.showName"
              placeholder="请填写分类名称"
            />
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="是否隐藏：" required prop="displayStatus">
            <el-radio-group v-model="rObject.displayStatus">
              <el-radio
                size="medium"
                v-for="(item, i) in displayStatusList"
                :key="i"
                :label="item.paramKey"
              >
                {{ item.paramValue }}
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <butn class="czButn" @click="isShow = false" title="取消"></butn>
      <butn btntype="primary" @click="submitForm" title="确定"></butn>
    </div>
  </el-dialog>
</template>

<script>
import butn from "@/components/button/index";
import Bus from "./Bus.js";
import rulesFactory from "@/utils/rules";
import {
  resCategoryInfo,
  resCategorySave,
  resCategoryUpdate
} from "@/api/rescategory";
import { getDataMap } from "@/api/sysParam";

export default {
  name: "curd",
  components: { butn },
  data() {
    return {
      isShow: false,
      title: "",
      displayStatusList: [],
      rObject: {
        displayStatus: "1",
        showName: ""
      },
      rules: {
        categoryName: [rulesFactory.required("请输入分类名称")]
      }
    };
  },
  methods: {
    input() {},
    blur() {},
    // 获取数据字典
    getSysParam(param) {
      getDataMap(param).then(res => {
        if (res && res.code == 0) {
          this.displayStatusList = res.data;
        }
      });
    },
    clearForm() {
      // 点击取消 数据重置
      this.$refs["rForm"].resetFields();
    },
    showFrom(msg) {
      this.isShow = true;
      this.title = msg;
    },
    info(uuid) {
      resCategoryInfo(uuid).then(res => {
        if (res && res.code == 0) {
          this.rObject = res.data;
          if (this.rObject.displayStatus !== '' || this.rObject.displayStatus !== 'undefined') {
            this.rObject.displayStatus = String(this.rObject.displayStatus)
          }
        }
      });
    },
    submitForm() {
      this.$refs["rForm"].validate(valid => {
        if (valid) {
          if (this.rObject.uuid == null) {
            // 新增
            resCategorySave(this.rObject).then(res => {
              if (res && res.code == 0) {
                this.isShow = false;
                Bus.$emit("initTable");
              }
            });
          } else {
            //编辑
            resCategoryUpdate(this.rObject).then(res => {
              if (res && res.code == 0) {
                this.isShow = false;
                Bus.$emit("initTable");
              }
            });
          }
        }
      });
    }
  },
  created() {
    this.getSysParam("DISPLAY_STATUS");
    Bus.$on("addRes", (pid, name) => {
      this.rObject.parentId = pid;
      this.showFrom(name);
    });
    Bus.$on("updateRes", uuid => {
      this.info(uuid);
      this.showFrom("编辑资源分类");
    });
  },
  beforeDestroy() {
    Bus.$off("addRes");
    Bus.$off("updateRes");
  }
};
</script>

<style lang="scss" scoped></style>
